export default {
  path: '/wecode/article',
  auth: false,
  preload: false,
  key: 'new-hardware-detail',
  component: () => import('./index')
};
